export default __webpack_public_path__ + "static/media/game_analyze_3.69b86987.png";